import React, { useEffect, useState } from "react";
import styles from "./SearchHistory.module.css";
import Button from "../Forms/Button";
import SelectedList from "../SelectedList/SelectedList";
import { historyOptionsType, optionsType } from "../Helper";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";
import 'dayjs/locale/pt-br';
import { fetchAllHistoryLogs } from "../../Services/Slices/getHistoryLogs";
import { fetchAllLogUsers } from "../../Services/Slices/allLogUsers";

interface iSearch {
  setFilters?: any;
  setBackup?: any;
  setSearch?: any;
  search?: any;
  onClearFilters?: any;
}

const SearchHistory: React.FC<iSearch> = ({
  setBackup,
  setSearch,
  onClearFilters,
  setFilters,
}) => {
  const [form, setForm] = useState({
    date: { from: null as Dayjs | null, to: null as Dayjs | null },
    atoType: [] as string[],
    action: [] as string[],
    user: [] as string[],
  });
  const [hasValue, setHasValue] = useState<boolean>(false);
  const dateFormat = "YYYY-MM-DD"
  const dispatch = useDispatch();
  const allUsers = useSelector((state: any) => state.AllLogUsersSlice);

  useEffect(() => {
    dispatch<any>(fetchAllLogUsers());
  }, [dispatch]);
  
  const handleDisable = () => {
    return (
      !form.date.from &&
      !form.date.to &&
      form.action.length === 0 &&
      form.atoType.length === 0 &&
      form.user.length === 0 &&
      !hasValue
    );
  };

  const handleSubmit = () => {
    const updatedRange = {
      ...form,
      ...(form.date.from || form.date.to
        ? {
            date: {
              from: form.date.from
              ? form.date.from.format(dateFormat)
              : null,
              to: form.date.to
                ? form.date.to.format(dateFormat)
                : form.date.from
            },
          }
        : {}),
        atoType: form.atoType, 
        action: form.action,  
        user: form.user,      
    };
    if (form.date.from && !form.date.to) {
      updatedRange.date.to = form.date.from.format(dateFormat);
    } else if (!form.date.from && form.date.to) {
      updatedRange.date.from = form.date.to.format(dateFormat);
    }
    dispatch<any>(fetchAllHistoryLogs(updatedRange, "1"));
    setBackup(updatedRange);
    setSearch(true);
  };

  const handleDateChange = (newDate: Dayjs | null, type: "from" | "to") => {
    setForm((prev) => ({
      ...prev,
      date: {
        ...prev.date,
        [type]: newDate,
      },
    }));
  };

  const handleClearFilters = () => {
    setSearch(false);
    setBackup({});
    setForm({
      date: { from: null, to: null },
      atoType: [],
      action: [],
      user: [],
    });
    setHasValue(false);
    onClearFilters && onClearFilters();
    };

    useEffect(() => {
      const allClear =
        !form.date.from &&
        !form.date.to &&
        form.atoType.length === 0 &&
        form.action.length === 0 &&
        form.user.length === 0 &&
        !hasValue;

      if (allClear) {
        onClearFilters && onClearFilters();
        setSearch(false);
        setBackup({});
        setHasValue(false);
      }
    }, [form, hasValue]);  
 
  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      adapterLocale="pt-br"
      >
      <div className={styles.container}>
        <div className={styles.align}>
          <div className={styles.inputContainer}>
            <div id="calendarsContainer" className={styles.calendarsContainer}>
              <div className={styles.calendar}>
                <DatePicker
                  label="Data Inicial"
                  dayOfWeekFormatter={(weekday) => `${weekday.format('dd')}`}
                  value={form.date.from}
                  desktopModeMediaQuery="(min-width: 0px)"
                  onChange={(newValue) => handleDateChange(newValue, "from")}
                  slotProps={{
                    textField: {
                      inputProps: {
                        placeholder: "DD/MM/AAAA",
                      },
                      sx: {
                        "&.MuiTextField-root": {
                          backgroundColor: "var(--second-button-color) ",
                          borderRadius: "5rem",
                          width: "100%",
                          boxShadow: "0 10px 10px -10px var(--shadow-color)",
                        },
                        "& .MuiOutlinedInput-root": {
                          height: "3rem",
                          borderRadius: "5rem",
                          fontFamily: "var(--montserrat-font)",
                          backgroundColor: "none",
                          "& fieldset": {
                            border: "none",
                            borderColor: "none",
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#4A4A4A",
                        },
                        "& .MuiInputLabel-root": {
                          fontFamily: "var(--montserrat-font)",
                          "&.Mui-focused": {
                            color: "#459436",
                          },
                        },
                      },
                    },
                    day: {
                      sx: {
                        "&.Mui-selected": {
                          backgroundColor: "var(--third-button-color) !important ",
                          "&:hover": {
                            backgroundColor: "var(--third-button-color-hover) !important",
                          },
                        },
                      }
                    }
                  }}
                />
              </div>
              <div className={styles.calendar}>
                <DatePicker
                  label="Data Final"
                  value={form.date.to}
                  dayOfWeekFormatter={(weekday) => `${weekday.format('dd')}`}
                  desktopModeMediaQuery="(min-width: 0px)"
                  onChange={(newValue) => handleDateChange(newValue, "to")}
                  slotProps={{
                    textField: {
                      inputProps: {
                        placeholder: "DD/MM/AAAA",
                      },
                      sx: {
                        "&.MuiTextField-root": {
                          backgroundColor: "var(--second-button-color) ",
                          width: "100%",
                          borderRadius: "5rem",
                          boxShadow: "0 10px 10px -10px var(--shadow-color)",
                        },
                        "& .MuiOutlinedInput-root": {
                          height: "3rem",
                          borderRadius: "5rem",
                          fontFamily: "var(--montserrat-font)",
                          backgroundColor: "none",
                          "& fieldset": {
                            border: "none",
                            borderColor: "none",
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#4A4A4A",
                        },
                        "& .MuiInputLabel-root": {
                          fontFamily: "var(--montserrat-font)",
                          "&.Mui-focused": {
                            color: "#459436",
                          },
                        },
                      },
                    },
                    day: {
                      sx: {
                        "&.Mui-selected": {
                          backgroundColor: "var(--third-button-color) !important ",
                          "&:hover": {
                            backgroundColor: "var(--third-button-color) ",
                          },
                        },
                      }
                    }
                  }}
                />
              </div>
            </div>
            <div className={styles.firstColumn}>
            <div id="type" className={styles.type}>
                  <SelectedList
                    placeholder="Tipo"
                    field="atoType"
                    list={form}
                    setList={setForm}
                    options={optionsType}
                    isType
                    readOnly
                  />
                </div>
              <div id="action" className={styles.action}>
                  <SelectedList
                    placeholder="Ação"
                    field="action"
                    list={form}
                    setList={setForm}
                    options={historyOptionsType}
                    isType
                    readOnly
                  />
                </div>
              <div id="keyword" className={styles.keyword}>
                <SelectedList
                      placeholder="Autor"
                      field="user"
                      list={form}
                      setList={setForm}
                      options={allUsers.data}
                      isType
                      readOnly
                    />
              </div>
            </div>
          </div>
          <div className={styles.lastColumn}>
            <div className={styles.info}>
              <Button id="searchButton" className={styles.button} onClick={handleSubmit} disabled={handleDisable()}>
                Pesquisar
              </Button>
              <Button className={styles.cleanButton} onClick={handleClearFilters} disabled={handleDisable()}>
                Limpar filtros
              </Button>
            </div>
          </div>
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default SearchHistory;